import React, { useState } from 'react'
import clsx from 'clsx'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleUp, faAngleDown } from '@fortawesome/free-solid-svg-icons'
import Button from './Button'

type Props = {
    children?: React.ReactNode
    title?: string
    titleType?: 'h1' | 'h2'
    subtitle?: string
    buttons?: React.ReactNode
    className?: string
    buttonPosition?: 'top' | 'bottom' | 'both'
    collapsible?: boolean
    defaultCollapsed?: boolean
}

function Section({
    children,
    title,
    titleType = 'h1',
    subtitle,
    buttons,
    className,
    buttonPosition = 'top',
    collapsible = false,
    defaultCollapsed = false,
}: Props): React.JSX.Element {
    const [isCollapsed, setIsCollapsed] = useState(defaultCollapsed)

    const toggleCollapse = () => setIsCollapsed(!isCollapsed)

    const baseTitleClasses = 'font-bold text-gray-700'
    const finalTitleClassName = clsx(baseTitleClasses, {
        'text-3xl': titleType === 'h1',
        'text-lg': titleType === 'h2',
    })

    return (
        <div className={className}>
            {/* Title and buttons container */}
            <div className="flex justify-between items-center">
                <div>
                    {subtitle && (
                        <p className="text-md font-bold text-gray-500">
                            {subtitle}
                        </p>
                    )}
                    <div className="flex items-center">
                        {title && (
                            <p className={finalTitleClassName}>{title}</p>
                        )}
                        {collapsible && (
                            <Button
                                onClick={toggleCollapse}
                                style="secondary"
                                type="button"
                                size="small"
                                classes="ml-2"
                            >
                                <FontAwesomeIcon
                                    icon={isCollapsed ? faAngleDown : faAngleUp}
                                />
                            </Button>
                        )}
                    </div>
                </div>
                <div className="flex gap-2">{buttons}</div>
            </div>
            {/* Content */}
            {!isCollapsed && (
                <>
                    <div>{children}</div>
                    <div className="flex justify-end mt-4">
                        {(buttonPosition === 'bottom' ||
                            buttonPosition === 'both') && (
                            <div className="flex gap-2">{buttons}</div>
                        )}
                    </div>
                </>
            )}
        </div>
    )
}

export default Section
